/**************************************************************************************************************************************************
*   MODULE NAME     :  ToggleSwitch
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  XX-XX-2021
*   DESCRIPTION     :  Toggle Switch Component
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import React, { Component } from "react";
import PropTypes from "prop-types";
import './ToggleSwitch.css'

/*
Toggle Switch Component
Note: id is required for ToggleSwitch component to function. Name, currentValue, defaultChecked, Small and onChange're optional.
Usage: <ToggleSwitch id="id" onChange={function (e) { console.log("Checkbox Current State: " + e.target.checked); }} />
*/

class ToggleSwitch extends Component {
   // Set text for rendering.
   static defaultProps = {
       Text: ["Required", "Optional"]
   };
   state = {
       checked: this.props.defaultChecked
   };
   /**
       * Function to handle onchange events
    **/
   onChange = (e) => {
       this.setState({
           checked: e.target.checked
       });
       if (typeof this.props.onChange === "function") this.props.onChange(e);
   }
   render () {
       return (
           <div
               className={"toggle-switch" + (this.props.Small ? " small-switch" : "")}
           >
               <input
                   type="checkbox"
                   name={this.props.Name}
                   className="toggle-switch-checkbox"
                   id={this.props.id}
                   checked={this.props.currentValue}
                   defaultChecked={this.props.defaultChecked}
                   onChange={this.onChange}
                   disabled={this.props.disabled}
               />
               {this.props.id ? (
                   <label className="toggle-switch-label" htmlFor={this.props.id}>
                       <span
                           className={
                               this.props.disabled ?
                                   "toggle-switch-inner toggle-switch-disabled" :
                                   "toggle-switch-inner"
                           }
                           data-yes={this.props.Text[0]}
                           data-no={this.props.Text[1]}
                       />
                       <span
                           className={
                               this.props.disabled ?
                                   "toggle-switch-switch toggle-switch-disabled" :
                                   "toggle-switch-switch"
                           }
                       />
                   </label>
               ) : null}
           </div>
       );
   }
}

ToggleSwitch.propTypes = {
    id: PropTypes.string.isRequired,
    Text: PropTypes.array.isRequired,
    Name: PropTypes.string,
    onChange: PropTypes.func,
    defaultChecked: PropTypes.bool,
    Small: PropTypes.bool,
    currentValue: PropTypes.bool,
    disabled: PropTypes.bool
};

export default ToggleSwitch;
